import { Checkbox } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const RecordingReady = observer(() => {
  const es = useStores().trackmanEventsEditorStore;

  return (
    <div className='checkboxes-container'>
      <Checkbox
        label='Recording ready'
        onChange={() => {
          es.eventItem.recordingReady = !es.eventItem.recordingReady;
          es.eventItem.videoId = '';
          es.isVideoIdSelected = false;
          es.eventItem.videoUrl = '';
          es.eventItem.videoLength = '';
          es.imagePreview = '';
          es.eventItem.imageUrl = '';
          delete es.eventItem.imageData;
          es.uploadedImageAccepted = false;
        }}
        checked={es.eventItem.recordingReady}
      />
    </div>
  );
});

export default RecordingReady;
